import { getAPIManagerInstance } from './apiManager';
import { DECKARD_API_URL, httpMethodFunctions } from './common';

export const getExpressConfig = async () => {
  const { data } = await httpMethodFunctions.get(
    `${DECKARD_API_URL}/stats?place=${getAPIManagerInstance().getPlaceUrl()}&is_portal=true`
  );
  return data;
};

export const getTranslationsAsync = async () => {
  const { data } = await httpMethodFunctions.get(
    `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/translations`
  );
  return data;
};
